import { client } from '@/client';
import { downloadFile } from '@/utils/common';

// 获取变量模板列表
export function getVariableStencilList(params) {
  return client.post(`/api/ops_var/stencil/list`, params);
}

// 克隆模版
export function cloneVariableStencil(id) {
  return client.post(`/api/ops_var/stencil/clone/${id}`);
}

// 查询模板变量详情
export function getVariableStencil(id) {
  return client.get(`/api/ops_var/stencil/detail/${id}`);
}

// 修改模板详情
export function updateVariableStencil(params) {
  return client.post('/api/ops_var/stencil/update', params);
}

// 更新所有变量
export function updateVariableStencilVars(params) {
  return client.post('/api/ops_var/stencil/detail/update', params);
}

// 删除模版
export function deleteVariableStencil(id) {
  return client.delete(`/api/ops_var/stencil/${id}`);
}

// 获取变量组列表
export function getVariableGroupList(params) {
  return client.post(`/api/ops_var/varGroup/list`, params);
}

// 新增变量组
export function addVariableGroup(params) {
  return client.post(`/api/ops_var/varGroup/add`, params);
}

// 修改变量组
export function updateVariableGroup(params) {
  return client.post(`/api/ops_var/varGroup/update`, params);
}

// 删除变量组
export function deleteVariableGroup(id) {
  return client.delete(`/api/ops_var/varGroup/${id}`);
}

// 获取变量列表
export function getVariableList(params) {
  return client.post(`/api/ops_var/var/list`, params);
}

// 新增变量
export function addVariable(params) {
  return client.post(`/api/ops_var/var/add`, params);
}

// 变量详情
export function getVariable(id) {
  return client.get(`/api/ops_var/varDetail/${id}`);
}

// 修改变量
export function updateVariable(params) {
  return client.post(`/api/ops_var/var/update`, params);
}

// 删除变量
export function deleteVariable(id) {
  return client.delete(`/api/ops_var/var/${id}`);
}

// 导出
export async function exportVariables(idList = []) {
  const { data } = await client.post('/api/ops_var/var/export', {
    idList,
  });
  downloadFile(new Blob([data], { type: 'application/json;charset=utf-8' }), '变量导出_');
}

// 导入变量
export function uploadFile(params) {
  return client.form('/api/ops_var/var/import', params);
}
